import React from 'react';
import { View, ImageBackground } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { VFText, Icon, IconTypes } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../FrameworkTestKeys';
import { getThemeImages } from '../../Themes';

import styles from './BackgroundView.Styles';

const BackgroundView = ({
  overlay,
  children,
  imageStyle,
  headerStyle,
  logoStyle,
  overlayStyle,
  textStyle,
  getLogoRef,
  theme,
  ...props
}) => {
  const setUpViewRef = logoView => {
    if (_isFunction(getLogoRef)) {
      getLogoRef(logoView);
    }
  };

  const Images = getThemeImages(theme.name);
  const { background = {} } = Images.TImages;

  return (
    <ImageBackground
      source={background.tertiary}
      style={[styles.containerStyle, imageStyle]}
      {...props}
    >
      <View style={styles.safeViewStyle}>
        {overlay ? <View style={[styles.overlayStyle, overlayStyle]} /> : null}
        <View style={[styles.imageContainerStyle, headerStyle]}>
          <View
            ref={setUpViewRef}
            style={[styles.logoStyle, logoStyle]}
            renderToHardwareTextureAndroid
          >
            <Icon
              type={IconTypes.image}
              name={Images.vfLogo}
              size={32}
              testId={FrameworkTestKeys.BackgroundViewVfLogo}
              accessibilityLabel={FrameworkTestKeys.BackgroundViewVfLogo}
            />
          </View>
          <VFText
            style={[styles.headerStyle, textStyle]}
            i18nKey="app_name"
            testId={FrameworkTestKeys.BackgroundViewVfTitle}
            testKey={FrameworkTestKeys.BackgroundViewVfTitle}
          />
        </View>
      </View>
      {children}
    </ImageBackground>
  );
};

BackgroundView.defaultProps = {
  theme: LightThemeColors,
  overlay: false,
  imageStyle: {},
  headerStyle: {},
  logoStyle: {},
  overlayStyle: {},
  textStyle: {},
};

BackgroundView.propTypes = {
  children: PropTypes.node,
  overlay: PropTypes.bool,
  imageStyle: ViewPropTypes.style,
  headerStyle: ViewPropTypes.style,
  logoStyle: ViewPropTypes.style,
  overlayStyle: ViewPropTypes.style,
  textStyle: TextPropTypes.style,
  getLogoRef: PropTypes.func,
  theme: PropTypes.object,
};

export default withTheme(BackgroundView);
